import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import { SERVICES } from '../data/services';

export default function Home() {
  const [hero, setHero] = useState({
    badge: 'Disponible pour de nouveaux projets',
    title: 'DESIGN QUI',
    subtitle: 'FAIT IMPACT',
    desc: '',
  });
  const [stats, setStats] = useState({
    s1: '50+', s1l: 'Projets réalisés',
    s2: '35+', s2l: 'Clients satisfaits',
    s3: '5+',  s3l: "Années d'expérience",
    s4: '∞',
  });

  useEffect(() => {
    document.title = 'HEYIMPURP — Portfolio Graphiste';
    const hd = JSON.parse(localStorage.getItem('hero_content') || 'null');
    if (hd) setHero(h => ({ ...h, ...hd }));
    const sd = JSON.parse(localStorage.getItem('stats_content') || 'null');
    if (sd) setStats(s => ({ ...s, ...sd }));
  }, []);

  return (
    <>
      <Nav />
      <section className="hero">
        <div className="hero-badge">{hero.badge}</div>
        <h1 className="hero-title">{hero.title}</h1>
        <h1 className="hero-title-gradient">{hero.subtitle}</h1>
        <p className="hero-sub">
          {hero.desc
            ? <span dangerouslySetInnerHTML={{ __html: hero.desc }} />
            : <>Graphiste <span>indépendant</span> basé en France. Je crée des identités visuelles, des interfaces et des univers graphiques qui marquent les esprits.</>
          }
        </p>
        <div className="hero-actions">
          <Link to="/portfolio" className="btn-primary">Voir mes projets →</Link>
          <Link to="/contact" className="btn-secondary">Travailler ensemble</Link>
        </div>
        <div className="scroll-hint">SCROLL</div>
      </section>

      <div className="stats">
        <div className="stat-item"><div className="stat-num">{stats.s1}</div><div className="stat-label">{stats.s1l}</div></div>
        <div className="stat-item"><div className="stat-num">{stats.s2}</div><div className="stat-label">{stats.s2l}</div></div>
        <div className="stat-item"><div className="stat-num">{stats.s3}</div><div className="stat-label">{stats.s3l}</div></div>
        <div className="stat-item"><div className="stat-num">{stats.s4}</div><div className="stat-label">Créativité</div></div>
      </div>

      <section className="section">
        <div className="section-label">Ce que je fais</div>
        <h2 className="section-title">MES<br />SPÉCIALITÉS</h2>
        <div className="services-grid">
          {SERVICES.map((s) => (
            <div className="service-card" key={s.num}>
              <div className="service-num" style={{ color: s.color }}>{s.num}</div>
              <div className="service-name">{s.name.split('\n').map((line, i) => <span key={i}>{line}{i === 0 && <br />}</span>)}</div>
              <p className="service-desc">{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <div className="cta-band">
        <h2>PRÊT À CRÉER<br />QUELQUE CHOSE ?</h2>
        <Link to="/contact" className="btn-white">Démarrer un projet</Link>
      </div>

      <Footer />
    </>
  );
}
